/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralExchangeRatesRepository = (
    options: GeneralRestApiOptions
): Types.GeneralExchangeRatesRepository => ({
    async getAll(params, requestOptions) {
        return options.request('/exchangeRates/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
